import { LearningContentText } from '@quebon/shared-learning/components/common/LearningContentText'

interface Props {
  correctCriteria?: string | null
  checkPoint?: string | null
}

function MetadataRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="grid gap-1 sm:grid-cols-[96px_minmax(0,1fr)] sm:gap-3">
      <dt className="text-xs font-semibold text-muted-foreground">{label}</dt>
      <dd className="whitespace-pre-wrap text-sm leading-6 text-foreground">
        <LearningContentText text={value} />
      </dd>
    </div>
  )
}

export function QuizReviewMetadata({ correctCriteria, checkPoint }: Props) {
  const criteria = correctCriteria?.trim()
  const teacherCheck = checkPoint?.trim()

  if (!criteria && !teacherCheck) return null

  return (
    <section
      aria-label="교사용 참고 정보"
      className="mt-4 rounded-lg border border-border bg-muted/40 p-4"
    >
      <dl className="space-y-3">
        {criteria ? <MetadataRow label="정답 기준" value={criteria} /> : null}
        {teacherCheck ? <MetadataRow label="선생님 체크" value={teacherCheck} /> : null}
      </dl>
    </section>
  )
}
